import React from "react";

const ErrorMessage = ({ message }) => {
  if (!message) return null; // Don't render the component if no error message is passed

  return (
    <div className="bg-red-500 text-white p-4 rounded-md mb-4">
      <p>{message}</p>
    </div>
  );
};

export default ErrorMessage;
